import React from "react";
import JsonView from "react18-json-view";
import "react18-json-view/src/style.css";

import { useAuth } from "../../contexts/AuthContext";
import { ProductCard } from "../../components/ui-new/ResultGrid";
import { useUserSessions } from "../../api/useUserSessions";

const AdminQueryPage = () => {
  const { isLoading } = useAuth();
  const [matches, setMatches] = React.useState([]);
  const [viewType, setViewType] = React.useState("json"); // "json" or "card"

  const { queryVectorStore } = useUserSessions();

  const search = async (query) => {
    if (!query) return;

    const results = await queryVectorStore(query, null);

    const {
      data: { matches = [] },
    } = results;
    for (let match of matches) {
      match.values = `(${match.values.length} values)`;
    }
    setMatches(matches);
    return matches;
  };

  if (isLoading) {
    return null;
  }

  return (
    <div className="min-h-screen relative overflow-hidden w-full">
      <div className="container mx-auto py-24 px-4 relative z-20 flex flex-col items-center">
        <div className="flex gap-10 items-center mb-4">
          <input
            onBlur={(e) => search(e.target.value)}
            className="text-xl p-4 border-2 border-gray-400 rounded-lg"
            placeholder="Search for something..."
          />
          <button
            onClick={() => console.log("Search button clicked")}
            className="h-10 flex items-center bg-gray-500 hover:bg-blue-600 text-white font-semibold px-6 py-3 rounded-lg shadow-md transition duration-300 ease-in-out"
          >
            Search
          </button>
        </div>

        <div className="flex space-x-4 mb-4">
          <button
            onClick={() => setViewType("json")}
            className={`px-4 py-2 rounded ${
              viewType === "json"
                ? "bg-blue-500 text-white"
                : "bg-gray-200 text-gray-700"
            }`}
          >
            JSON View
          </button>
          <button
            onClick={() => setViewType("card")}
            className={`px-4 py-2 rounded ${
              viewType === "card"
                ? "bg-blue-500 text-white"
                : "bg-gray-200 text-gray-700"
            }`}
          >
            Product Card View
          </button>
        </div>

        {matches.length > 0 && viewType === "json" && (
          <JsonView src={matches} collapsed={2} dark={true} />
        )}

        {matches.length > 0 && viewType === "card" && (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 w-full">
            {matches.map((m, index) => (
              <div key={index} className="bg-white shadow rounded-lg p-6">
                <ProductCard
                  product={m.metadata}
                  setSelectedProduct={() => console.log(m)}
                />
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default AdminQueryPage;
